import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { setPushableDevice } from "vue-app/api/SettingsService";

const handlePushNotification = () => {
  const firebaseConfig = {
    apiKey: "AIzaSyCefhRJ41u3NPuNzW7aPzCLM-pz6O1Enss",
    authDomain: "edrone-push.firebaseapp.com",
    databaseURL: "https://edrone-push.firebaseio.com",
    projectId: "edrone-push",
    storageBucket: "edrone-push.firebasestorage.app",
    messagingSenderId: "428525938108",
    appId: "1:428525938108:web:48849a7ba745edeebf37b9",
  };

  try {
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    if (Notification.permission !== "granted") {
      try {
        Notification.requestPermission();
      } catch (error) {
        console.error("Error requesting notification permission:", error);
      }
    }

    if (Notification.permission === "granted") {
      navigator.serviceWorker.register("/firebase-messaging-sw.js").then((registration) => {
        console.log("Service Worker registered with scope:", registration.scope);

        getToken(messaging, {
          vapidKey: "BMNW5qrZ61AWDJWBzY1uJornmtJrejjGMvCanmv0thneAMwy2ZXZH17gZ48o5nRqNfNmIYE48RLra1SvUeWmtQ8",
        })
          .then((currentToken) => {
            setPushableDevice(currentToken);
          })
          .catch((err) => {
            console.error("An error occurred while retrieving token. ", err);
          });
      });
    }
  } catch (error) {
    console.error("Error initializing Firebase:", error);
  }
};

if (window.EDRONE_CONTEXT.user.isDev) {
  handlePushNotification();
}
